export default __webpack_public_path__ + "static/media/stunningpunch2.96b5d330.png";